import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { IconTravellerCrossed } from "@/components/Icons";
import { type Traveller } from "@/types/types";

const ICON_SIZE = 60;

function DeleteTraveller({
  traveller,
  closeDrawer,
  deleteTraveller,
}: {
  traveller: Traveller;
  closeDrawer: () => void;
  deleteTraveller: () => void;
}) {
  const intl = useIntl();

  const fullName = `${traveller.firstName} ${traveller.lastName}`;
  const removeTravellerHandler = () => {
    deleteTraveller();
    closeDrawer();
  };

  return (
    <div className="flex h-full w-full flex-col items-center">
      <IconTravellerCrossed
        width={ICON_SIZE}
        height={ICON_SIZE}
        className="border-b-1 border-b-semantic-error-strong"
      />
      <h5 className="mt-6 mb-3 text-base leading-6 font-medium text-text-title">
        {intl.formatMessage({
          id: "travellers.deletePerson",
          defaultMessage: "Delete the traveller?",
        })}
      </h5>
      <span
        className="mb-11 text-sm font-normal text-text-placeholder"
        data-sentry-mask
      >
        {intl.formatMessage(
          {
            id: "travellers.deleteName",
            defaultMessage: "Delete {fullName} traveller from your list?",
          },
          { fullName },
        )}
      </span>
      <div className="mt-auto flex w-full flex-col gap-2">
        <Button
          onClick={removeTravellerHandler}
          variant="contained"
          color="error"
        >
          {intl.formatMessage({ id: "delete", defaultMessage: "Delete" })}
        </Button>
        <Button onClick={closeDrawer} variant="text">
          {intl.formatMessage({ id: "cancel", defaultMessage: "Cancel" })}
        </Button>
      </div>
    </div>
  );
}

export default DeleteTraveller;
